import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlightContext } from './useFlightContext';

const useFlightSearchParams = () => {
    const { flightSearchParams , setFlightSearchParams } = useFlightContext();
    const { i18n } = useTranslation();

    const updateFlightSearchParams = useCallback((name , value) => {
      setFlightSearchParams((prevState) => {
            if (prevState === null) {
              return { [name]: value };
            }
            return { ...prevState, [name]: value };

        });
    }, [setFlightSearchParams]);

    const updateTravelers = (type, action) => {
        let inc = -1;
        if (action === "ADD") inc = 1;
        switch (type) {
        case "ADT":
            if (flightSearchParams.nrOfAdult === 9 && inc === 1) return;
            if (flightSearchParams.nrOfAdult + flightSearchParams.nrOfSenior <= 1 && inc === -1) return;
            updateFlightSearchParams("nrOfAdult", (flightSearchParams?.nrOfAdult || 0) + inc);
            break;
          case "CHD":
            if (flightSearchParams.nrOfChild === 9 && inc === 1) return;
            if (flightSearchParams.nrOfChild === 0 && inc === -1) return;
            updateFlightSearchParams("nrOfChild", (flightSearchParams?.nrOfChild || 0) + inc);
            break;
          case "INF":
            if (flightSearchParams.nrOfInfant === 9 && inc === 1) return;
            if (flightSearchParams.nrOfInfant === 0 && inc === -1) return;
            updateFlightSearchParams("nrOfInfant", (flightSearchParams?.nrOfInfant || 0) + inc);
            break;
          case "infantWithSeat":
            if (flightSearchParams.nrOfInfantWithSeat === 9 && inc === 1) return;
            if (flightSearchParams.nrOfInfantWithSeat === 0 && inc === -1) return;
            updateFlightSearchParams("nrOfInfantWithSeat", (flightSearchParams?.nrOfInfantWithSeat || 0) + inc);
            break;
          case "youth":
            if (flightSearchParams.nrOfYouth === 9 && inc === 1) return;
            if (flightSearchParams.nrOfYouth === 0 && inc === -1) return;
            updateFlightSearchParams("nrOfYouth", (flightSearchParams?.nrOfYouth || 0) + inc);
            break;
        case "senior":
            if (flightSearchParams.nrOfSenior === 9 && inc === 1) return;
            if (flightSearchParams.nrOfAdult + flightSearchParams.nrOfSenior <= 1 && inc === -1) return;
            updateFlightSearchParams("nrOfSenior", (flightSearchParams?.nrOfSenior || 0) + inc);
            break;
          default:
            return;
        }
    };
    
    const getTravelersCount = () => {
        return (
          flightSearchParams.nrOfAdult +
          flightSearchParams.nrOfChild +
          flightSearchParams.nrOfInfant +
          flightSearchParams.nrOfInfantWithSeat +
          flightSearchParams.nrOfYouth +
          flightSearchParams.nrOfSenior
        );
    };

    const isReadyToSearch = ()=>{

      if(flightSearchParams?.tripType === "rt"){
        if (!flightSearchParams?.departureOption1 ||
            !flightSearchParams?.arrivalOption1 ||
            !flightSearchParams.departureDate1) return false
        // return date required only when openReturn is false (same logic as b2c-prototype)
        if (!flightSearchParams.openReturn && !flightSearchParams.departureDate2) return false
      }

      for(let i = 1; i <= flightSearchParams?.numberOfBounds; i++){
        if (!flightSearchParams[`departureOption${i}`] ||
            !flightSearchParams[`arrivalOption${i}`] ||
            !flightSearchParams[`departureDate${i}`]) return false
      }


      return true
    }

    const prepareAvailabilityPayload = ()=>{

      const locations = {}
      const dates = {}
      if (flightSearchParams?.tripType === "rt") {
        locations.origin_1 = flightSearchParams?.departureOption1?.iata ?? "";
        locations.destination_1 = flightSearchParams?.arrivalOption1?.iata ?? "";
        locations.origin_2 = flightSearchParams?.arrivalOption1?.iata ?? "";
        locations.destination_2 = flightSearchParams?.departureOption1?.iata ?? "";
        dates.departureDate_1 = flightSearchParams?.departureDate1;
        dates.departureDate_2 = flightSearchParams?.departureDate2;
      }else{
        if(flightSearchParams?.tripType === "ow"){
          locations.origin_1 = flightSearchParams?.departureOption1?.iata ?? "";
          locations.destination_1 = flightSearchParams?.arrivalOption1?.iata ?? "";
          dates.departureDate_1 = flightSearchParams?.departureDate1;

        }else{
          for(let i = 1; i <= flightSearchParams?.numberOfBounds; i++){
            locations[`origin_${i}`] = flightSearchParams[`departureOption${i}`].iata ?? "";
            locations[`destination_${i}`] = flightSearchParams[`arrivalOption${i}`].iata ?? "";
            dates[`departureDate_${i}`] = flightSearchParams[`departureDate${i}`];
          }
        }

      }

      localStorage.setItem("flightSearchParams", JSON.stringify(flightSearchParams));

      return {
          ...locations,
          ...dates,
          cabinClass: flightSearchParams?.cabinClass,
          refundable: flightSearchParams?.refundable,
          directFlight: flightSearchParams?.directFlight,
          flexible: flightSearchParams?.flexible,
          tripType: flightSearchParams?.tripType,
          nrOfAdult: flightSearchParams?.nrOfAdult,
          nrOfChild: flightSearchParams?.nrOfChild,
          nrOfInfant: flightSearchParams?.nrOfInfant,
          nrOfInfantWithSeat: flightSearchParams?.nrOfInfantWithSeat,
          nrOfYouth: flightSearchParams?.nrOfYouth,
          nrOfSenior: flightSearchParams?.nrOfSenior,
          requestedMultiCity: flightSearchParams?.tripType === "mc" ? "1" : "0",
          requestedFlightNonStop: flightSearchParams?.directFlight ? "1" : "0",
          range: flightSearchParams?.flexible ? "3" : "0",
          withBaggage: flightSearchParams?.withBaggage,
          openReturn: flightSearchParams?.openReturn ? "true" : "false",
          bounds: flightSearchParams?.tripType === "rt" ? "2" : ""+ flightSearchParams?.numberOfBounds,
          language: i18n.language,
        };
    }
  

    return {
        updateFlightSearchParams,
        updateTravelers,
        getTravelersCount,
        isReadyToSearch,
        prepareAvailabilityPayload,
    };
}

export default useFlightSearchParams;